module.exports = __webpack_public_path__ + "static/media/photo.3bae9a47.jpg";